/* =========================================================================
   vh life — Premium Video Hero (framework-free, vanilla JS)
   Single seamless PING-PONG video loop (forward + reverse encode), so it loops
   with no hard cut and NO crossfade ghosting. Respects prefers-reduced-motion
   and rests on the static poster if autoplay is blocked. Pauses when scrolled
   out of view to save battery.
   ========================================================================= */
(function () {
  "use strict";

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }

  function initHero(root) {
    if (!root || root.__vhInit) return;
    root.__vhInit = true;

    var media = root.querySelector(".vh-hero__media");
    if (!media) return;

    var video = media.querySelector(".vh-media__video");
    var poster = media.querySelector(".vh-media__poster");

    function showPoster() { if (poster) poster.classList.add("is-visible"); }
    function hidePoster() { if (poster) poster.classList.remove("is-visible"); }

    if (!video || prefersReducedMotion()) {
      showPoster();
      if (video) { try { video.pause(); } catch (e) {} }
      return;
    }

    function attemptPlay() {
      try {
        var p = video.play();
        if (p && p.then) { p.then(hidePoster).catch(showPoster); }
        else { hidePoster(); }
      } catch (e) { showPoster(); }
    }
    // Codec safety net. A webm that a browser refuses to DECODE (bad colour
    // tagging, unsupported profile) leaves the hero frozen on frame one with no
    // automatic fallback. On any media error, drop the webm source and reload
    // from the mp4; if that fails too, rest on the poster.
    var triedMp4Only = false;
    function fallbackToMp4() {
      if (triedMp4Only) { showPoster(); return; }
      triedMp4Only = true;
      var mp4 = video.querySelector('source[type="video/mp4"]');
      if (!mp4 || !mp4.src) { showPoster(); return; }
      var t = video.currentTime || 0;
      video.innerHTML = "";
      video.src = mp4.src;
      video.load();
      try { video.currentTime = t; } catch (e) {}
      attemptPlay();
    }
    video.addEventListener("error", fallbackToMp4);
    // The error can also land on the <source> element rather than the media element.
    Array.prototype.forEach.call(video.querySelectorAll("source"), function (s) {
      s.addEventListener("error", function () {
        if (video.error || video.readyState < 2) fallbackToMp4();
      });
    });

    attemptPlay();

    // Recovery: if the first attempt ran in a hidden/background tab, Chrome
    // rejects autoplay and we'd rest on the poster forever. Retry whenever the
    // page becomes visible again, on bfcache restore, and on the first user
    // interaction (a gesture always unlocks playback).
    function retryIfStalled() {
      if (video.paused) attemptPlay();
    }
    document.addEventListener("visibilitychange", function () {
      if (!document.hidden) retryIfStalled();
    });
    window.addEventListener("pageshow", retryIfStalled);
    ["scroll", "pointerdown", "touchstart", "keydown"].forEach(function (evt) {
      window.addEventListener(evt, retryIfStalled, { once: true, passive: true });
    });

    // Pause when off-screen, resume when back in view.
    if ("IntersectionObserver" in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) { attemptPlay(); }
          else { try { video.pause(); } catch (e) {} }
        });
      }, { threshold: 0.05 });
      io.observe(media);
    }
  }

  function initAll(scope) {
    var nodes = (scope || document).querySelectorAll("[data-vh-hero]");
    for (var i = 0; i < nodes.length; i++) initHero(nodes[i]);
  }

  if (document.readyState !== "loading") { initAll(); }
  else { document.addEventListener("DOMContentLoaded", function () { initAll(); }); }

  document.addEventListener("shopify:section:load", function (e) {
    var node = e.target.querySelector("[data-vh-hero]");
    if (node) { node.__vhInit = false; initHero(node); }
  });
})();

/* Mobile menu toggle + close-on-click (added for nav wiring). */
(function () {
  "use strict";
  function wire(root) {
    var nav = root.querySelector(".vh-nav");
    var btn = root.querySelector(".vh-nav__menu");
    if (!nav || !btn || btn.__wired) return;
    btn.__wired = true;
    btn.setAttribute("aria-expanded", "false");
    btn.addEventListener("click", function () {
      var open = nav.classList.toggle("is-open");
      btn.setAttribute("aria-expanded", open ? "true" : "false");
    });
    nav.querySelectorAll(".vh-nav__links a").forEach(function (a) {
      a.addEventListener("click", function () {
        nav.classList.remove("is-open");
        btn.setAttribute("aria-expanded", "false");
      });
    });
    document.addEventListener("click", function (e) {
      if (!nav.contains(e.target)) { nav.classList.remove("is-open"); btn.setAttribute("aria-expanded", "false"); }
    });
  }
  function init() { document.querySelectorAll("[data-vh-hero]").forEach(wire); }
  if (document.readyState !== "loading") init();
  else document.addEventListener("DOMContentLoaded", init);
  document.addEventListener("shopify:section:load", init);
})();
